import { render, staticRenderFns } from "./DataContractEmployee.vue?vue&type=template&id=d6490790&"
import script from "./DataContractEmployee.vue?vue&type=script&lang=js&"
export * from "./DataContractEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports